<template>
  <div class="container DDList">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item href="" @click.native="() => $router.replace('/')"
        >首页</a-breadcrumb-item
      >
      <a-breadcrumb-item
        href=""
        @click.native="() => $router.replace('/onlineRegistrationV2')"
        >预约挂号</a-breadcrumb-item
      >
      <a-breadcrumb-item>搜索科室/医生</a-breadcrumb-item>
    </a-breadcrumb>

    <a-tabs v-model="activeKey" @change="tabChange">
      <a-tab-pane :key="item.key" :tab="item.name" v-for="item in tabs"> </a-tab-pane>
    </a-tabs>

    <a-space class="date-select">
      <a-input-search
        v-model="searchText"
        placeholder="请输入名称进行搜索"
        size="large"
        style="width: 100%"
        :loading="searchLoading"
        :disabled="searchLoading"
        enter-button
        allowClear
        @search="onSearch"
        class="search-input"
    /></a-space>

    <!--科室列表-->
    <div class="content" v-if="activeKey == 1">
      <a-card
        hoverable
        class="item-card"
        :key="item.ghksdm"
        v-for="item in list"
        @click="jumpDocList(item.ghksdm)"
      >
        <h3>
          {{ item.ghksmc }}
        </h3>
        <div class="fontColor">{{ item.yqmc }}</div>
      </a-card>
    </div>
    <!--医生列表-->
    <div class="content" v-else-if="activeKey == 2">
      <a-card
        hoverable
        class="item-card"
        v-for="(item, index) in list"
        :key="index"
        @click="onDetail(item)"
      >
        <img
          v-if="item.headerImg"
          :src="item.headerImg"
          @error="onImgError(index)"
          alt=""
        />
        <img v-else src="@/assets/img/doc.png" alt="" />

        <h3>
          {{ item.ygxm }} <span>{{ item.ygzc }}</span>
        </h3>
        <div class="fontColor">{{ item.ghksmc }}</div>
        <div class="fontColor">{{ item.yqmc }}</div>
      </a-card>
    </div>
    <a-empty v-if="isNo" />
  </div>
</template>

<script>
import { queryDoctorInfo, queryDepartmentInfo } from "@/api/registration";
export default {
  data() {
    return {
      searchLoading: false,
      isNo: false,
      searchText: "",
      activeKey: "1",
      tabs: [
        { key: "1", name: "查询科室" },
        { key: "2", name: "查询医生" },
      ],
      list: [
        {
          consultAvgReplyTime: 62,
          consultCount: 13,
          docAvatar:
            "http://file.gjwlyy.com/group1/M00/00/82/CghDGlpkJYSAKH-DAABPKOSe3XQ9689816",
          docBookStatus: false,
          docCcpRole: 0,
          docDeptName: "内分泌科",
          docFamousConsultStatus: false,
          docGender: "F",
          docHosName: "浙大二院",
          docId: "594a4ed2e4b064976980857d",
          docName: "楼寒钰",
          docPicConsultStatus: true,
          docResume: "内分泌疾病的综合诊治",
          docScoure: 10,
          docSkill: "内分泌疾病的综合诊治",
          docTitle: "主治医师",
          docType: "DOC",
          docVideoConsultStatus: false,
          follow: false,
          renewalOpenStatus: false,
          selectedStatus: false,
          teamConsultStatus: false,
        },
      ],
      department: [],
    };
  },

  methods: {
    onImgError(i){
    this.list[i].headerImg=require('@/assets/img/doc.png');
    },
    //修改分类
    tabChange() {
      this.searchText = "";
      this.searchData();
    },
    //获取科室数据
    async getDepartmentData() {
      const params = {};
      if (this.searchText) {
        params.ksmc = this.searchText;
      }
      const { code, data } = await queryDepartmentInfo(params);
      this.searchLoading = false;
      if (code == 200) {
        if (data.length > 0) {
          this.list = data;
        } else {
          this.isNo = true;
        }
      }
    },
    //获取医生数据
    async getDoctorData() {
      const params = {};
      if (this.searchText) {
        params.ysxm = this.searchText;
      }
      const { code, data } = await queryDoctorInfo(params);
      this.searchLoading = false;
      if (code == 200) {
        if (data.length > 0) {
          this.list = data;
        } else {
          this.isNo = true;
        }
      }
    },
    onSearch() {
      this.searchData();
    },
    searchData() {
      //记录查询条件
      this.$router.push({
        path: "/DDList",
        query: {
          searchText: this.searchText,
          key: this.activeKey,
        },
      });
      //查询
      this.searchLoading = true;
      this.isNo = false;
      this.list = [];
      if (this.activeKey == 1) {
        this.getDepartmentData();
      } else {
        this.getDoctorData();
      }
    },
    jumpDocList(mzks) {
      this.$router.push({
        path: "/doctorList",
        query: { mzks },
      });
    },
    onDetail(item) {
      let data = {
        ...item,
        ysdm: item.ygdm,
      };
      this.$router.push({
        path: "/doctorDetailV2",
        query: { data: JSON.stringify(data) },
      });
    },
  },
  created() {
    this.searchText = this.$route.query.searchText ? this.$route.query.searchText : "";
    this.activeKey = this.$route.query.key ? this.$route.query.key : "1";
    this.searchData();
  },
  beforeDestroy() {
    this.$notification.destroy();
  },
};
</script>

<style lang="scss" scoped>
.fontstyle {
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
}

.container {
  .date-select {
    padding: 20px;
    margin-bottom: 20px;
    width: 100%;
    border-radius: 4px;
    background: #f8f8f8;
    .ant-space-item {
      width: 100%;
    }

    .date-label {
      font-size: 16px;
    }

    .activedDay {
      color: #fff;
      background-color: #3f86ff;
    }
  }

  .select {
    .title {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      padding-right: 30px;

      h3 {
        font-size: 20px;
      }

      .line {
        width: 100px;
        height: 2px;
        background: #000;
      }
    }
  }

  .select-box {
    display: flex;
    justify-content: center;
    padding: 20px 0;

    h3 {
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: #f8f8f8;
      font-size: 16px;
      font-weight: 400;
      color: #999999;
    }

    .select-hospital {
      flex: 3;
      border: 1px solid #f8f8f8;

      .hospital-item {
        cursor: pointer;
        height: 50px;
        box-sizing: border-box;
        font-size: 16px;
        text-align: center;
        line-height: 50px;
      }
    }

    .select-department {
      flex: 5;
      border: 1px solid #f8f8f8;
      padding: 0 16px;
    }

    .department-content {
      height: 500px;
      overflow-y: auto;
      overflow-x: hidden;
    }

    .select-doctor {
      flex: 4;
      cursor: pointer;
      box-sizing: border-box;
      font-size: 16px;
      border: 1px solid #f8f8f8;
      margin-left: -1px;

      .list-item {
        display: flex;
        padding: 16px;
        align-items: center;
        border-bottom: 1px solid #f8f8f8;
        cursor: pointer;

        img {
          text-align: center;
          width: 80px;
          height: 80px;
          margin-right: 12px;
          border-radius: 50%;
          border: 1px solid #f8f8f8;
        }

        .list-pro-name {
          .item-name {
            margin: 2px 0;
          }

          .item-name {
            font-size: 14px;

            &-text {
              font-size: 22px;
              color: #333;
              font-weight: 600;
            }

            &-job {
              color: #333;
              padding: 0 10px;
            }

            &-tf {
              padding: 1px 4px;
              color: #3f86ff;
              border: 1px solid #3f86ff;
              border-radius: 2px;
              margin-right: 4px;
            }
          }

          .item-department-name {
            margin-top: 4px;
            color: #666;
          }

          .item-skilled {
            margin-top: 4px;
            width: 65%;
            color: #666;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }

  .actived,
  .activedDepartmentStyle {
    font-weight: bold;
    background-color: rgba(63, 134, 255, 0.07) !important;
  }
}

.content {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  .item-card {
    width: 220px;
    margin: 0 7px;
    text-align: center;
    margin-bottom: 15px;
    img {
      height: 60px;
      width: 60px;
      border-radius: 50%;
      margin-bottom: 10px;
    }
    h3 {
      text-align: center;
      font-size: 16px;
      span {
        font-size: 14px;
        color: #666;
      }
    }

    .fontColor {
      font-size: 14px;
      text-align: center;
      color: #a9a9a9;
    }
  }
}
</style>
